
<div id="prueba">
    <h1><strong>You are logged out</strong></h1>
</div>
<section class="container mt-4">
    <p>Gracias por preferir All Tickets</p>
</section>
